export default __webpack_public_path__ + "static/media/visa.a9c914c9.svg";